import {PageTypes} from '@aboutyou/router';

export const getTransactionName = (url: string, pageType?: PageTypes) => {
  if (!pageType) {
    return 'unknown';
  }

  let transactionName = pageType.toLowerCase();

  if (
    transactionName.includes('articledetail') &&
    /[?&]quick=view/gi.test(url)
  ) {
    transactionName = `${transactionName}/quickView`;
  }

  if (transactionName.includes('category') && url.includes('?')) {
    // separate category pages that contain params (e.g. filter)
    transactionName = `${transactionName}/withQueryParams`;
  }

  return transactionName.toLowerCase();
};
